import React, {Component} from "react"
import PropTypes from "prop-types"
import {FormattedMessage} from "@irati/utils/lang"
import {deleteSaml} from "@irati/sso/services/sso"
import businessService from "@irati/identity/services/business"
import ValidationButton from "@irati/ui/src/FormItem/ValidationButton"
import Loading from "@irati/ui/src/Loading"

class SAMLDeactivated extends Component {
  static propTypes = {
    userTenant: PropTypes.object,
    handleSave: PropTypes.func
  }

  static defaultProps = {
    userTenant: {},
    handleSave: () => {}
  }

  constructor(props) {
    super(props)
    this.state = {
      loading: false
    }
  }

  changeSignUpOption = () => {
    const saving = deleteSaml()
      .then(() => {
        const {userTenant} = this.props

        const data = {
          uuid: userTenant.uuid,
          showPasswordLogin: true,
          showSsoLogin: false
        }
        return businessService.update({data}).then(() => {
          this.props.handleSave()
        })
      })
      .catch((err) => {
        this.setState({loading: false})
        throw new Error(err)
      })
    this.setState({
      saving,
      isLoading: true
    })
  }

  render() {
    return (
      <div>
        <ValidationButton small type="button" className="pull-right" onClick={this.changeSignUpOption}>
          {this.state.isLoading ? (
            <FormattedMessage id="admin.components.samlDeactivated.validationButton.saving" />
          ) : (
            <FormattedMessage id="admin.components.samlDeactivated.validationButton.save" />
          )}
        </ValidationButton>
        <Loading load={this.state.saving} useLoader={false} />
      </div>
    )
  }
}

export default SAMLDeactivated
